import type { RegentsQuestion } from './regentsTest1';

export const regentsTest4: RegentsQuestion[] = [
  {
    id: 1,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Equations',
    standard: 'A-REI.B.3',
    question: 'Solve: (x/4) − 3 = 5',
    options: ['x = 8', 'x = 32', 'x = 2', 'x = 20'],
    correctAnswer: 1,
    solution: [
      'Add 3 to both sides: x/4 = 8',
      'Multiply both sides by 4: x = 32'
    ]
  },
  {
    id: 2,
    type: 'multiple-choice',
    points: 2,
    topic: 'Factoring — Difference of Squares',
    standard: 'A-SSE.A.2',
    question: 'Factor: 9x² − 64',
    options: ['(3x − 8)(3x + 8)', '(9x − 8)(x + 8)', '(3x − 8)²', '(3x + 8)²'],
    correctAnswer: 0,
    solution: [
      'Recognize the difference of squares pattern: a² − b²',
      '9x² = (3x)² and 64 = 8²',
      'Apply: (3x − 8)(3x + 8)',
      'Check: (3x)² − 8² = 9x² − 64 ✓'
    ]
  },
  {
    id: 3,
    type: 'multiple-choice',
    points: 2,
    topic: 'Function Notation',
    standard: 'F-IF.A.2',
    question: 'If h(x) = x² − 2x + 3, what is h(3)?',
    options: ['6', '9', '12', '3'],
    correctAnswer: 0,
    solution: [
      'Substitute x = 3: h(3) = (3)² − 2(3) + 3',
      '= 9 − 6 + 3',
      '= 6'
    ]
  },
  {
    id: 4,
    type: 'multiple-choice',
    points: 2,
    topic: 'Systems of Equations — Substitution',
    standard: 'A-REI.C.6',
    question: 'Solve: y = 4x − 1 and 2x + y = 11. What is x?',
    options: ['x = 1', 'x = 2', 'x = 3', 'x = 4'],
    correctAnswer: 1,
    solution: [
      'Substitute y = 4x − 1 into 2x + y = 11',
      '2x + (4x − 1) = 11',
      '6x − 1 = 11',
      '6x = 12',
      'x = 2'
    ]
  },
  {
    id: 5,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quadratic Formula',
    standard: 'A-REI.B.4',
    question: 'Solve using the quadratic formula: x² − 6x + 8 = 0',
    options: ['x = 2 or x = 4', 'x = −2 or x = −4', 'x = 3 or x = 5', 'x = 1 or x = 8'],
    correctAnswer: 0,
    solution: [
      'a = 1, b = −6, c = 8',
      'Discriminant: (−6)² − 4(1)(8) = 36 − 32 = 4',
      'x = (6 ± √4) / 2 = (6 ± 2) / 2',
      'x = 8/2 = 4 or x = 4/2 = 2',
      'Solutions: x = 2 or x = 4'
    ]
  },
  {
    id: 6,
    type: 'multiple-choice',
    points: 2,
    topic: 'Exponential Functions',
    standard: 'F-LE.A.2',
    question: 'A bank account starts with $1,000 and earns 4% interest annually. Which function models the balance B after t years?',
    options: ['B = 1000(1.04)^t', 'B = 1000 + 0.04t', 'B = 1000(0.96)^t', 'B = 1000(4)^t'],
    correctAnswer: 0,
    solution: [
      'Compound interest uses exponential growth',
      'Growth factor = 1 + rate = 1 + 0.04 = 1.04',
      'B = 1000(1.04)^t',
      'Check t = 1: B = 1000(1.04) = $1,040 ✓'
    ]
  },
  {
    id: 7,
    type: 'multiple-choice',
    points: 2,
    topic: 'Polynomial Multiplication',
    standard: 'A-APR.A.1',
    question: 'Multiply: (x + 3)(x² − 2x + 4)',
    options: ['x³ + x² − 2x + 12', 'x³ + x² + 10x + 12', 'x³ − 2x² + 4x + 12', 'x³ + x² − 2x − 12'],
    correctAnswer: 0,
    solution: [
      'Distribute x: x(x² − 2x + 4) = x³ − 2x² + 4x',
      'Distribute 3: 3(x² − 2x + 4) = 3x² − 6x + 12',
      'Add: x³ − 2x² + 4x + 3x² − 6x + 12',
      'Combine like terms: x³ + x² − 2x + 12'
    ]
  },
  {
    id: 8,
    type: 'multiple-choice',
    points: 2,
    topic: 'Inequalities — Compound',
    standard: 'A-REI.B.3',
    question: 'Solve: −3 < 2x + 1 ≤ 9',
    options: ['−2 < x ≤ 4', '−1 < x ≤ 5', '−2 ≤ x < 4', '−4 < x ≤ 2'],
    correctAnswer: 0,
    solution: [
      'Subtract 1 from all parts: −3 − 1 < 2x ≤ 9 − 1',
      '−4 < 2x ≤ 8',
      'Divide all parts by 2: −2 < x ≤ 4',
      'Solution: −2 < x ≤ 4'
    ]
  },
  {
    id: 9,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Functions',
    standard: 'F-IF.B.4',
    question: 'The function f(x) = −2x + 10 is decreasing. For what values of x is f(x) > 0?',
    options: ['x < 5', 'x > 5', 'x < −5', 'x > −5'],
    correctAnswer: 0,
    solution: [
      'Set f(x) > 0: −2x + 10 > 0',
      'Subtract 10: −2x > −10',
      'Divide by −2 and flip: x < 5',
      'f(x) > 0 when x < 5'
    ]
  },
  {
    id: 10,
    type: 'multiple-choice',
    points: 2,
    topic: 'Completing the Square',
    standard: 'A-REI.B.4',
    question: 'Solve by completing the square: x² + 10x = −9',
    options: ['x = −1 or x = −9', 'x = 1 or x = 9', 'x = −1 or x = 9', 'x = 1 or x = −9'],
    correctAnswer: 0,
    solution: [
      'Add (10/2)² = 25 to both sides: x² + 10x + 25 = −9 + 25',
      '(x + 5)² = 16',
      'Take square root: x + 5 = ±4',
      'x = −5 + 4 = −1 or x = −5 − 4 = −9'
    ]
  },
  {
    id: 11,
    type: 'multiple-choice',
    points: 2,
    topic: 'Rational Exponents',
    standard: 'N-RN.A.2',
    question: 'Rewrite ⁵√x³ using a rational exponent.',
    options: ['x^(3/5)', 'x^(5/3)', 'x^(1/5)', 'x^(15)'],
    correctAnswer: 0,
    solution: [
      'The index of the root becomes the denominator',
      'The power of x becomes the numerator',
      '⁵√x³ = x^(3/5)'
    ]
  },
  {
    id: 12,
    type: 'multiple-choice',
    points: 2,
    topic: 'Statistics — Standard Deviation',
    standard: 'S-ID.A.2',
    question: 'Two classes have the same mean score of 75. Class A has a standard deviation of 3, Class B has a standard deviation of 12. What does this tell us?',
    options: [
      'Class A performed better overall',
      'Class B performed better overall',
      'Class A scores are more consistent (less spread)',
      'Class B scores are more consistent (less spread)'
    ],
    correctAnswer: 2,
    solution: [
      'Standard deviation measures the spread of data around the mean',
      'A smaller standard deviation means data is clustered closer to the mean',
      'Class A (SD = 3) has scores more tightly clustered around 75',
      'Answer: Class A scores are more consistent (less spread)'
    ]
  },
  {
    id: 13,
    type: 'multiple-choice',
    points: 2,
    topic: 'Graphing Quadratics',
    standard: 'F-IF.C.7',
    question: 'The parabola f(x) = −3x² + 6x − 1 opens:',
    options: ['Upward, with a minimum', 'Downward, with a maximum', 'Upward, with a maximum', 'Downward, with a minimum'],
    correctAnswer: 1,
    solution: [
      'The leading coefficient is a = −3',
      'When a < 0, the parabola opens downward',
      'A downward parabola has a maximum (highest point)',
      'Answer: Downward, with a maximum'
    ]
  },
  {
    id: 14,
    type: 'multiple-choice',
    points: 2,
    topic: 'Creating Equations — Word Problems',
    standard: 'A-CED.A.1',
    question: 'The sum of three consecutive integers is 48. What is the smallest integer?',
    options: ['14', '15', '16', '17'],
    correctAnswer: 1,
    solution: [
      'Let the integers be n, n+1, n+2',
      'n + (n+1) + (n+2) = 48',
      '3n + 3 = 48',
      '3n = 45',
      'n = 15 (smallest integer)'
    ]
  },
  {
    id: 15,
    type: 'multiple-choice',
    points: 2,
    topic: 'Transformations of Functions',
    standard: 'F-BF.B.3',
    question: 'How does f(x) = −x² compare to f(x) = x²?',
    options: [
      'Shifted downward',
      'Reflected over the x-axis',
      'Reflected over the y-axis',
      'Stretched vertically'
    ],
    correctAnswer: 1,
    solution: [
      'Multiplying f(x) by −1 reflects the graph over the x-axis',
      'f(x) = x² opens upward; f(x) = −x² opens downward',
      'This is a reflection over the x-axis',
      'Answer: Reflected over the x-axis'
    ]
  },
  {
    id: 16,
    type: 'multiple-choice',
    points: 2,
    topic: 'Factoring Trinomials',
    standard: 'A-SSE.B.3',
    question: 'Factor: 6x² − 7x − 3',
    options: ['(3x + 1)(2x − 3)', '(6x + 1)(x − 3)', '(3x − 1)(2x + 3)', '(2x − 3)(3x + 1)'],
    correctAnswer: 0,
    solution: [
      'Multiply a × c: 6 × (−3) = −18',
      'Find two numbers that multiply to −18 and add to −7: −9 and 2',
      'Rewrite: 6x² − 9x + 2x − 3',
      'Factor by grouping: 3x(2x − 3) + 1(2x − 3)',
      'Answer: (3x + 1)(2x − 3)'
    ]
  },
  {
    id: 17,
    type: 'multiple-choice',
    points: 2,
    topic: 'Slope and Rate of Change',
    standard: 'F-IF.B.6',
    question: 'A car travels 240 miles in 4 hours. What is the average rate of change (speed)?',
    options: ['40 mph', '50 mph', '60 mph', '80 mph'],
    correctAnswer: 2,
    solution: [
      'Rate of change = change in distance / change in time',
      '= 240 miles / 4 hours',
      '= 60 miles per hour',
      'Answer: 60 mph'
    ]
  },
  {
    id: 18,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Exponential Functions',
    standard: 'F-LE.B.5',
    question: 'In f(t) = 500(0.8)^t, what does 0.8 tell us?',
    options: [
      'The quantity grows by 80% each period',
      'The quantity decays by 20% each period',
      'The initial value is 0.8',
      'The quantity decays by 80% each period'
    ],
    correctAnswer: 1,
    solution: [
      'The base 0.8 = 1 − 0.20 is the decay factor',
      'Since 0.8 < 1, the function represents decay',
      'The quantity decreases by 20% each period',
      'Answer: The quantity decays by 20% each period'
    ]
  },
  {
    id: 19,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Systems — Infinitely Many Solutions',
    standard: 'A-REI.C.6',
    question: 'The system 2x + 4y = 8 and x + 2y = 4 has:',
    options: ['One solution', 'No solution', 'Infinitely many solutions', 'Two solutions'],
    correctAnswer: 2,
    solution: [
      'Divide the first equation by 2: x + 2y = 4',
      'This is identical to the second equation',
      'The two equations represent the same line',
      'Answer: Infinitely many solutions'
    ]
  },
  {
    id: 20,
    type: 'multiple-choice',
    points: 2,
    topic: 'Zeros and Factors',
    standard: 'A-APR.B.3',
    question: 'If P(x) = x² − 3x − 10 and P(5) = 0, which is a factor?',
    options: ['(x + 5)', '(x − 5)', '(x − 3)', '(x + 10)'],
    correctAnswer: 1,
    solution: [
      'By the Factor Theorem: if P(a) = 0, then (x − a) is a factor',
      'P(5) = 0, so (x − 5) is a factor',
      'Verify: x² − 3x − 10 = (x − 5)(x + 2) ✓',
      'Answer: (x − 5)'
    ]
  },
  {
    id: 21,
    type: 'multiple-choice',
    points: 2,
    topic: 'Irrational Numbers',
    standard: 'N-RN.B.3',
    question: 'Which is a rational number?',
    options: ['√3 + √5', '√3 × √12', '√7 − 1', 'π + 2'],
    correctAnswer: 1,
    solution: [
      '√3 × √12 = √(3 × 12) = √36 = 6',
      '6 is an integer, which is rational',
      'All other options result in irrational numbers',
      'Answer: √3 × √12 = 6'
    ]
  },
  {
    id: 22,
    type: 'multiple-choice',
    points: 2,
    topic: 'Writing Linear Equations',
    standard: 'A-CED.A.2',
    question: 'Write the equation of the line with slope 3 passing through (2, 7).',
    options: ['y = 3x + 1', 'y = 3x + 7', 'y = 3x − 1', 'y = 7x + 3'],
    correctAnswer: 0,
    solution: [
      'Use point-slope form: y − y₁ = m(x − x₁)',
      'y − 7 = 3(x − 2)',
      'y − 7 = 3x − 6',
      'y = 3x + 1'
    ]
  },
  {
    id: 23,
    type: 'multiple-choice',
    points: 2,
    topic: 'Histograms',
    standard: 'S-ID.A.1',
    question: 'A histogram shows test scores: 60–69 (5 students), 70–79 (12 students), 80–89 (18 students), 90–99 (8 students). How many students scored 80 or above?',
    options: ['18', '26', '30', '43'],
    correctAnswer: 1,
    solution: [
      'Students scoring 80–89: 18',
      'Students scoring 90–99: 8',
      'Total scoring 80 or above: 18 + 8 = 26',
      'Answer: 26 students'
    ]
  },
  {
    id: 24,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quadratic Applications',
    standard: 'A-CED.A.1',
    question: 'A ball is thrown upward. Its height is h(t) = −16t² + 48t + 5. What is the initial height?',
    options: ['5 feet', '16 feet', '48 feet', '0 feet'],
    correctAnswer: 0,
    solution: [
      'The initial height is when t = 0',
      'h(0) = −16(0)² + 48(0) + 5 = 5',
      'Initial height = 5 feet'
    ]
  },
  {
    id: 25,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Graphs of Functions',
    standard: 'F-IF.B.4',
    question: 'A function f(x) has a y-intercept of 4 and x-intercepts at x = −2 and x = 3. Which could be f(x)?',
    options: ['f(x) = (x + 2)(x − 3)', 'f(x) = −(2/3)(x + 2)(x − 3)', 'f(x) = (x − 2)(x + 3)', 'f(x) = 2(x + 2)(x − 3)'],
    correctAnswer: 1,
    solution: [
      'x-intercepts at x = −2 and x = 3 means factors (x + 2) and (x − 3)',
      'Check y-intercept: f(0) = a(0 + 2)(0 − 3) = a(2)(−3) = −6a',
      'Set −6a = 4: a = −2/3',
      'f(x) = −(2/3)(x + 2)(x − 3)'
    ]
  },
  {
    id: 26,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Equations — Fractions',
    standard: 'A-REI.B.3',
    question: 'Solve: (2x + 1)/3 = 5',
    options: ['x = 7', 'x = 8', 'x = 14', 'x = 4'],
    correctAnswer: 0,
    solution: [
      'Multiply both sides by 3: 2x + 1 = 15',
      'Subtract 1: 2x = 14',
      'Divide by 2: x = 7'
    ]
  },
  {
    id: 27,
    type: 'multiple-choice',
    points: 2,
    topic: 'Geometric Sequences',
    standard: 'F-LE.A.2',
    question: 'A geometric sequence has first term 3 and common ratio 4. What is the 4th term?',
    options: ['48', '64', '192', '768'],
    correctAnswer: 2,
    solution: [
      'Formula: aₙ = a₁ × r^(n−1)',
      'a₄ = 3 × 4^(4−1) = 3 × 4³',
      '= 3 × 64 = 192',
      'Answer: 192'
    ]
  },
  {
    id: 28,
    type: 'multiple-choice',
    points: 2,
    topic: 'Scatter Plot — Line of Best Fit',
    standard: 'S-ID.B.6',
    question: 'A line of best fit for data is y = 2.5x + 10. Predict y when x = 8.',
    options: ['20', '25', '30', '35'],
    correctAnswer: 2,
    solution: [
      'Substitute x = 8 into the equation',
      'y = 2.5(8) + 10',
      'y = 20 + 10 = 30',
      'Predicted value: 30'
    ]
  },
  {
    id: 29,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Quadratics — All Methods',
    standard: 'A-REI.B.4',
    question: 'Which method is most efficient for solving x² − 25 = 0?',
    options: ['Quadratic formula', 'Completing the square', 'Square root method', 'Graphing'],
    correctAnswer: 2,
    solution: [
      'x² − 25 = 0 can be rewritten as x² = 25',
      'Taking the square root directly: x = ±5',
      'The square root method is most efficient here',
      'Answer: Square root method'
    ]
  },
  {
    id: 30,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Parameters',
    standard: 'F-LE.B.5',
    question: 'In the linear function f(x) = 3x + 12, what does 12 represent in a real-world context?',
    options: [
      'The rate of change',
      'The starting value when x = 0',
      'The maximum value',
      'The slope'
    ],
    correctAnswer: 1,
    solution: [
      'In f(x) = mx + b, b is the y-intercept',
      'The y-intercept is the value of f when x = 0',
      'f(0) = 3(0) + 12 = 12',
      'Answer: The starting value when x = 0'
    ]
  }
];
